// Schedule
const ScheduleContainer = () => import("@/views/schedule/containers/DefaultContainer")
const ScheduleIndex = () => import("@/views/schedule/views/StartingPage")
const ScheduleView = () => import("@/views/schedule/views/ScheduleView")
const VCView = () => import("@/views/schedule/views/VCView")

const routes = [
    {
        path: "/schedule",
        component: ScheduleContainer,
        meta: {
            label: "Schedule"
        },
        children: [
            {
                path: "",
                component: ScheduleIndex,
                meta: {
                    roleRequired: ["physician"],
                    label: "Welcome"
                }
            },
            {
                path: ":consultationId",
                props: true,
                component: ScheduleView,
                meta: {
                    roleRequired: ["physician"],
                },
                children: [
                    {
                        path: ":viewName",
                        props: true,
                        name: 'schedule-vc-view',
                        component: VCView,
                        meta: {
                            label: "Patient"
                        },
                    },
                ]
            },
        ]
    }
]

export default routes
